import Brightness1OutlinedIcon from "@mui/icons-material/Brightness1Outlined";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Box,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import ScatterPlotIcon from "@mui/icons-material/ScatterPlot";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import { checkPermission } from "../../../utils/Validation/checkPermission";
import PropTypes from "prop-types";

const MenuItems = ({ item, open, setOpen, route, main, level = 0 }) => {
  const [{ permission }] = useDataLayerValue();
  const [active, setActive] = useState(false);
  const link = route + item.link;
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname.includes(item.link)) {
      setActive(true);
    }
  }, [location.pathname, item.link]);

  const checkMenu = (item) => {
    let data = false;
    if (item.type) return true;

    item?.subMenu?.forEach((sub) => {
      if (sub?.subMenu) {
        data = checkMenu(sub);
      } else if (checkPermission(permission, "read_per", sub?.title, link)) {
        data = true;
      }
    });
    return data;
  };

  const hasPermission =
    permission &&
    ((item?.subMenu && checkMenu(item)) || item?.type
      ? true
      : checkPermission(permission, "read_per", item?.title, link));

  if (!hasPermission) return null;

  return (
    <div>
      <ListItem
        key={item.title}
        onClick={() => {
          if (item.subMenu) {
            setOpen(true);
            setActive(!active);
          } else {
            navigate(link);
          }
          if (item?.onClick) {
            item?.onClick();
            navigate("/login");
          }
        }}
        disablePadding
        sx={{
          display: "block",
          marginLeft: `${level * 8}px`,
          background: main
            ? "#262626"
            : !item.subMenu && location.pathname.includes(link)
            ? "red"
            : "black",
          borderRadius: "5px",
          marginBottom: "5px",
        }}
      >
        <ListItemButton
          sx={{
            minHeight: 48,
            justifyContent: open ? "initial" : "center",
            px: 2.5,
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: 0,
              mr: open ? 2 : "auto",
              justifyContent: "center",
              color: "white",
            }}
          >
            {item.icon ? (
              React.cloneElement(item.icon, {
                sx: { fontSize: 22, color: "white" },
              })
            ) : item?.space ? (
              <ScatterPlotIcon sx={{ fontSize: 20, color: "white" }} />
            ) : (
              <Brightness1OutlinedIcon sx={{ fontSize: 20, color: "white" }} />
            )}
          </ListItemIcon>
          <ListItemText
            primary={item?.title}
            sx={{ opacity: open ? 1 : 0 }}
          />
          {item.subMenu && (
            <Box
              sx={{
                minWidth: 0,
                opacity: open ? 1 : 0,
                justifyContent: "center",
                color: "white",
                marginLeft: "auto",
              }}
            >
              {active ? (
                <ExpandMoreIcon sx={{ color: "white" }} />
              ) : (
                <ChevronLeftIcon sx={{ color: "white" }} />
              )}
            </Box>
          )}
        </ListItemButton>
      </ListItem>

      {active &&
        item?.subMenu?.map((sub, index) => (
          <MenuItems
            key={index}
            setOpen={setOpen}
            route={link}
            open={open}
            item={sub}
            level={level + 1}
          />
        ))}
    </div>
  );
};

MenuItems.propTypes = {
  item: PropTypes.any.isRequired,
  open: PropTypes.any.isRequired,
  setOpen: PropTypes.any.isRequired,
  route: PropTypes.any,
  main: PropTypes.any,
};

export default MenuItems;
